module.exports = __webpack_public_path__ + "static/media/footer-bg.6e7841b5.png";